import { SVGProps } from '@components/Icon/types';

export const MoveFolder = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <path
      d="M12.1709 10.6543C12.4173 10.4328 12.797 10.4529 13.0186 10.6992L15.5 13.46C15.5073 13.4681 15.5127 13.4779 15.5195 13.4863C15.534 13.5043 15.5482 13.5224 15.5605 13.542C15.5678 13.5536 15.5736 13.5662 15.5801 13.5781C15.5917 13.5997 15.6034 13.6215 15.6123 13.6445C15.618 13.6594 15.6215 13.6752 15.626 13.6904C15.6314 13.7087 15.6379 13.7271 15.6416 13.7461C15.6461 13.7696 15.6477 13.7936 15.6494 13.8174C15.6505 13.8315 15.6543 13.846 15.6543 13.8604C15.6542 13.8824 15.6498 13.9043 15.6475 13.9258C15.6459 13.9409 15.6464 13.9567 15.6436 13.9717C15.6392 13.9947 15.6309 14.017 15.624 14.0391C15.6199 14.0523 15.6164 14.0662 15.6113 14.0791C15.6031 14.1 15.5924 14.12 15.582 14.1396C15.5748 14.1533 15.5679 14.1675 15.5596 14.1807C15.5473 14.1999 15.5338 14.2186 15.5195 14.2363C15.513 14.2445 15.5071 14.2539 15.5 14.2617L13.0186 17.0234C12.797 17.2694 12.4172 17.2896 12.1709 17.0684C11.9248 16.847 11.905 16.4681 12.126 16.2217L13.707 14.4609H8.90039C8.56929 14.4608 8.30006 14.1914 8.2998 13.8604C8.30023 13.5294 8.56939 13.2609 8.90039 13.2607H13.7061L12.126 11.501C11.9047 11.2548 11.9251 10.8759 12.1709 10.6543Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.58008 2.5C9.16388 2.5 9.71867 2.75502 10.0986 3.19824L12.2002 5.65039C12.3902 5.87201 12.6681 6 12.96 6H18.5C20.7091 6 22.5 7.79086 22.5 10V17.5C22.5 19.64 20.8194 21.3879 18.7061 21.4951L18.5 21.5H5.5C3.29088 21.5 1.50003 19.7091 1.5 17.5V6.5C1.5 4.29086 3.29086 2.5 5.5 2.5H8.58008ZM5.5 3.90039C4.06406 3.90039 2.90039 5.06406 2.90039 6.5V17.5C2.90042 18.9359 4.06408 20.0996 5.5 20.0996H18.5C19.9359 20.0996 21.0996 18.9359 21.0996 17.5V10C21.0996 8.56406 19.9359 7.40039 18.5 7.40039H12.96C12.2594 7.40039 11.5937 7.09345 11.1377 6.56152L9.03613 4.10938C8.92214 3.97639 8.75523 3.90039 8.58008 3.90039H5.5Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'moveFolder';
